<!--
运营商信息展示，含头像、名称、简称

用法：
<lc-service-provider :service-provider="serviceProvider"></lc-service-provider>
-->
<template>
  <div class="lc-sp clearfix">
    <router-link :to="spDetailRouter(serviceProvider)" :event="spDetailEvent()">
      <el-avatar :src="serviceProvider.logo" shape="square" :size="size"></el-avatar>
    </router-link>

    <div class="m-l-5">
      <router-link v-if="canAccessSp" :to="spDetailRouter(serviceProvider)" :event="spDetailEvent()">
        <el-tooltip v-if="textOverflowLimit" :content="serviceProvider.name" effect="dark" placement="left">
          <div class="name text-overflow">{{ serviceProvider.name }}</div>
        </el-tooltip>
        <div v-else>{{ serviceProvider.name }}</div>
      </router-link>

      <div v-if="!canAccessSp">
        <div class="name text-overflow">{{ serviceProvider.name }}</div>
      </div>
      <div class="short-name">{{ serviceProvider.short_name }}</div>
    </div>
  </div>
</template>

<script>
import Auth from '@/helpers/authorizations'

export default {
  props: {
    /**
     * 运营商信息
     * 结构: {id, logo, name, short_name}
     */
    serviceProvider: {
      type: Object,
      default: () => {}
    },
    size: {
      type: Number,
      default: 30
    },
    textOverflowLimit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return { Auth }
  },
  computed: {
    // 是否能访问运营商
    canAccessSp() {
      // 如果是父运营商，并且没有权限访问父运营商详情，则不能访问
      return this.currentServiceProvider.parent_id !== this.serviceProvider.id
    }
  },
  methods: {
    /**
     * 运营商的路由信息
     *
     * @param {object} sp 运营商
     * @returns {string} 详情页路由。如果没有权限，则不显示路由
     */
    spDetailRouter(sp) {
      if (!this.can(Auth.showServiceProvider)) {
        return ''
      }
      return `/service_providers/${sp.id}/detail`
    },
    /**
     * 运营商详情页的事件
     *
     * @returns {string} 当事件为 '' 时，router link 点击不会跳转
     */
    spDetailEvent() {
      return this.can(Auth.showServiceProvider) ? 'click' : ''
    },
    /**
     * 拷贝内容
     *
     * @param {string} cellId 要拷贝的Cell的ID
     */
    copy(cellId) {
      /* Get the text field */
      let copyTextElem = document.getElementById(cellId)

      let range, selection

      if (document.body.createTextRange) {
        range = document.body.createTextRange()
        range.moveToElementText(copyTextElem)
        range.select()
      } else if (window.getSelection) {
        selection = window.getSelection()
        range = document.createRange()
        range.selectNodeContents(copyTextElem)
        selection.removeAllRanges()
        selection.addRange(range)
      }

      try {
        document.execCommand('copy')
        this.$toast.success(`${this.$t('charger.tips.copy_success')} ${copyTextElem.textContent}`)
      } catch (err) {
        this.$toast.error(this.$t('charger.tips.copy_fail'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-sp {
  display: flex;
}
.name {
  color: #333;
  line-height: 18px;
  max-width: 130px;
  margin-bottom: -5px;
}
.short-name {
  font-size: 12px;
  color: #999;
  line-height: 12px;
}
.text-overflow {
  display: inline-block;
  width: 100%;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
</style>
